import { AgentEffectCommands } from "~/business";
import { XAgentEffect } from "./XAgentEffect";
import { XPlayerIcon } from "./XPlayerIcon";
import { Colors, Spacing } from "~/jsx/theme";
import { motion } from "~/utils";

const effectBoxWidth = 140;
const playerIconWidth = 24;

export const XFreighterRamp = ({
  levels,
}: {
  levels: { playerId: string; level: number }[];
}) => {
  const {
    or,
    spice,
    garnison,
    chooseFactionChange,
    acquireTechTile,
    opponentsSolaris,
    and,
  } = AgentEffectCommands;
  const freighterEffects = [
    acquireTechTile({ discount: 2 }),
    and([garnison(2), chooseFactionChange(1)]),
    or([opponentsSolaris({ personalAmount: 5, opponentsAmount: 1 }), spice(2)]),
  ];
  return (
    <div
      style={{
        backgroundColor: Colors.yellow.main,
        width: "fit-content",
        boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      {freighterEffects.map((effect, levelIndex) => (
        <div key={levelIndex} style={{ display: "flex" }}>
          <div
            style={{
              border: "solid 1px black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "fit-content",
              padding: Spacing.px8,
            }}
          >
            {levels.map(({ playerId, level }) =>
              level === 3 - levelIndex ? (
                <motion.div
                  layoutId={`freighter-flag-${playerId}`}
                  key={playerId}
                >
                  <XPlayerIcon width={24} playerId={playerId} />
                </motion.div>
              ) : (
                <div key={playerId} style={{ width: 24 }}></div>
              )
            )}
          </div>
          <div
            style={{
              border: "solid 1px black",
              width: effectBoxWidth,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: Spacing.px8,
            }}
          >
            <XAgentEffect
              effectDescription={effect}
              context="card"
              width={32}
            />
          </div>
        </div>
      ))}
      <div
        style={{
          border: "solid 1px black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {levels.map(({ playerId, level }) =>
          level === 0 ? (
            <motion.div layoutId={`freighter-flag-${playerId}`} key={playerId}>
              <XPlayerIcon width={playerIconWidth} playerId={playerId} />
            </motion.div>
          ) : (
            <div key={playerId} style={{ width: playerIconWidth }}></div>
          )
        )}
        <div
          style={{ width: effectBoxWidth, height: 16 + playerIconWidth }}
        ></div>
      </div>
    </div>
  );
};
